<template>

        <div class="picture1" v-onmedia="matchMedia">
        <!--<div class="picture1">-->

            <div id="home" style="height:90px;"></div>

            <!--
            <div id="people" class="container people-width">
                <div class="row mt-md-5 pb-md-0 mb-4">

                    <div class="col-md-1 col-lg-2 col-xl-3 d-none d-md-block"></div>
                    <div class="col-12 col-md-10 col-lg-8 col-xl-6">
                        <div class="d-flex justify-content-around pt-3">
                            <div class="form-group checkbox-rounded-heimanns-red">
                                <input type="checkbox" class="filled-in" id="checkbox_a_z" v-on:change="filterMedia('a_z')" v-model="a_z">
                                <label for="checkbox_a_z">A-Z</label>
                            </div>

                            <div class="form-group checkbox-rounded-heimanns-red">
                                <input type="checkbox" class="filled-in" id="checkbox_a_f" v-on:change="filterMedia('a_f')" v-model="actor_female" checked="checked">
                                <label for="checkbox_a_f">Damen</label>
                            </div>

                            <div class="form-group checkbox-rounded-heimanns-red">
                                <input type="checkbox" class="filled-in" id="checkbox_a_m" v-on:change="filterMedia('a_m')" v-model="actor_male" checked="checked">
                                <label for="checkbox_a_m">Herren</label>
                            </div>
                        </div>
                    </div>
 
                    <div class="col-md-1 col-lg-2 col-xl-3 d-none d-md-block"></div>
                </div>          
                <hr class="mt-0 mb-5 px-4">                             
            </div>
            -->
            <div id="people" style="height:20px;"></div>

            <section-people-row 
                v-for="actorsPerLine in actorsPerLines" 
                :actorsPerLine="actorsPerLine"
                :numberOfActorsPerLine="numberOfActorsPerLine" 
                :matchedSize="matchedSize"
                :isSameLineFn="isSameLineFn"
                :isSameActorFn="isSameActorFn"
                :key="actorsPerLine.line">
            </section-people-row>

        </div>
   
</template>

<script>
    import {eventBus} from './../main'
    import PeopleRow from "./PeopleRow"
    import url from "./../config"

    export default {
        components: {
            sectionPeopleRow: PeopleRow
        },
        data () {
            return {
                matchedSize : '',
                all: true,
                ladies: true,
                gents: true,
                a_z: true,
                acting: true,
                presenting: false,
                actor_male: true,
                actor_female: true,
                moderator_male: true,
                moderator_female: true,
                selectedLine : '',
                selectedActorId : -1,
                numberOfActorsPerLine : 3,
                hash: location.hash,
                deeplinkActor: null,
                allActors : [
/*                    {
                        'pv_id': 53,
                        'pv_vorname' : 'Jesse',
                        'pv_nachname' : 'Albert',
                        'pv_geschlecht' : 'm',
                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/53_ov_1408633333.png'
                    },
                    {
                        'pv_id': 67,
                        'pv_vorname' : 'Nagmeh',
                        'pv_nachname' : 'Alaei',
                        'pv_geschlecht' : 'w',
                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/67_ov_1492093007.png'
                    },
                    {
                        'pv_id': 5,
                        'pv_vorname' : 'Jochen',
                        'pv_nachname' : 'Alexander Wigand',
                        'pv_geschlecht' : 'm',
                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/5_ov_1508159939.png'
                    },
                    {
                        'pv_id': 56,
                        'pv_vorname' : 'Julia',
                        'pv_nachname' : 'Schmitt',
                        'pv_geschlecht' : 'w',
                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/56_ov_1480512250.png'
                    },
                    {
                        'pv_id': 16,
                        'pv_vorname' : 'Sema',
                        'pv_nachname' : 'Wittgenstein (vormals Meray)',
                        'pv_geschlecht' : 'w',
                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/16_ov_1513001090.png'
                    }
*/
                ],
                dummyActor : {
                    'pv_id': -1,
                    'pv_vorname' : '',
                    'pv_nachname' : '',
                    'pv_geschlecht' : '',
                    'pv_bild': ''
                },
/*                actorsPerLines : [
                    {
                        line : 'line1',
                        actors : [ 
                            {
                                'pv_id': 53,
                                'name': 'Jesse Albert',
                                'image': 'http://heimanns-agentur.de/medien/bilder/53_ov_1408633333.png'
                            },
                            {
                                'pv_id': 67,
                                'name': 'Nagmeh Alaei',
                                'image': 'http://heimanns-agentur.de/medien/bilder/67_ov_1492093007.png'
                            },
                            {
                                'pv_id': 5,
                                'name': 'Jochen Alexander Wigand',
                                'image': 'http://heimanns-agentur.de/medien/bilder/5_ov_1508159939.png'
                            }
                        ]
                    }, 
                    {
                        line : 'line2',                           
                        actors : [ 
                            {
                                'pv_id': 56,
                                'name': 'Julia Schmitt',
                                'image': 'http://heimanns-agentur.de/medien/bilder/56_ov_1480512250.png'
                            },
                            {
                                'pv_id': 16,
                                'name': 'Sema Wittgenstein (vormals Meray)',
                                'image': 'http://heimanns-agentur.de/medien/bilder/16_ov_1513001090.png'
                            },
                            {
                                'pv_id': -1,
                                'name': '',
                                'image': 'http://heimanns-agentur.de/medien/bilder/16_ov_1513001090.png'
                            },
                        ]
                    }
                ] */               
                actorsPerLines : [],
                scrollTop: 0
            }
        },
        methods: {
            matchMedia(alias, matches) {
                if (alias === 'xs' && matches) {
                    console.log("xs");
                    this.matchedSize = 'xs';
                } else if (alias === 'sm' && matches) {
                    console.log("sm");
                    this.matchedSize = 'sm';
                } else if (alias === 'md' && matches) {
                    console.log("md");
                    this.matchedSize = 'md';
                } else if (alias === 'lg' && matches) {
                    console.log("lg");
                    this.matchedSize = 'lg';
                } else if (alias === 'xl' && matches) {
                    console.log("xl");
                    this.matchedSize = 'xl';
                } 
                this.startUpdate();
            },
            startUpdate() {
                if (this.matchedSize === 'xs') {
                    this.updateActorsPerLines (1, true);
                } else if (this.matchedSize === 'sm') {
                    this.updateActorsPerLines (2, true);
                } else if (this.matchedSize === 'md') {
                    this.updateActorsPerLines (3, true);
                } else if (this.matchedSize === 'lg') {
                    this.updateActorsPerLines (4, true);
                } else if (this.matchedSize === 'xl') {
                    this.updateActorsPerLines (5, true);
                } 
                
            },
            hideAllCollapsedContent(selectedActorLine) {
                //alert("selectedActorLine " + JSON.stringify(selectedActorLine));
                this.actorsPerLines.forEach(actorsPerLine => {
                    if (selectedActorLine.line !== actorsPerLine.line) {
                        $('#'+actorsPerLine.line).collapse('hide');
                    } 
                });
            },
            isSameLineFn(line) {
                //console.log ("Selected line is: " + this.selectedLine);
                //alert("Line:" + line + "/actorId:" + actorId + 
                //" -- selectedLine:" + this.selectedLine + "/selectedActorId:" + this.selectedActorId);
                return (line === this.selectedLine);
            },
            isSameActorFn(actorId) {
                //console.log ("Selected actorId is: " + this.selectedActorId);
                //alert("Line:" + line + "/actorId:" + actorId + 
                //" -- selectedLine:" + this.selectedLine + "/selectedActorId:" + this.selectedActorId);
                return (actorId === this.selectedActorId);
            },
            sortActorsAlphabetically() {
                //https://stackoverflow.com/questions/6712034/sort-array-by-firstname-alphabetically-in-javascript
                    const normalize = (str) => str
                        .toLowerCase()
                        .replace(/ä/g, 'ae')
                        .replace(/ö/g, 'oe')
                        .replace(/ü/g, 'ue')
                        .replace(/ß/g, 'ss');

                this.allActors.sort(function(a, b){
                    var name1 = normalize(a.pv_nachname + '_' + a.pv_vorname);
                    var name2 = normalize(b.pv_nachname + '_' + b.pv_vorname);
                    return name1.localeCompare(name2);
                });          
            },
            shuffleAllActors() {
                //https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
                var currentIndex = this.allActors.length, temporaryValue, randomIndex;
                // While there remain elements to shuffle...
                while (0 !== currentIndex) {
                    // Pick a remaining element...
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;
                    // And swap it with the current element.
                    temporaryValue = this.allActors[currentIndex];
                    this.allActors[currentIndex] = this.allActors[randomIndex];
                    this.allActors[randomIndex] = temporaryValue;
                }               
            },
            filterMedia(changedCheckbox) {
                // Prevent that all checkboxes are unchecked
                var randomizeAllActorsList = false;
            /*    if(changedCheckbox === 'a_f') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.actor_female = true;
                        return;
                    }
                }
                if(changedCheckbox === 'a_m') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.actor_male = true;
                        return;
                    }
                }
                if(changedCheckbox === 'm_f') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.moderator_female = true;
                        return;
                    }
                }
                if(changedCheckbox === 'm_m') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.moderator_male = true;
                        return;
                    }
                }*/
                if(changedCheckbox === 'a_f') {
                    if(!this.actor_female && !this.actor_male) {
                        this.actor_female = true;
                        return;
                    }
                }
                if(changedCheckbox === 'a_m') {
                    if(!this.actor_female && !this.actor_male) {
                        this.actor_male = true;
                        return;
                    }
                }
                /*
                if(changedCheckbox === 'all') {
                    if(this.all) {
                        this.ladies = false;
                        this.gents = false;
                    }
                }
                if(changedCheckbox === 'ladies') {
                    if(this.ladies) {
                        this.all = false;
                        this.gents = false;
                    } else if(!this.gents) {
                        this.ladies = true;
                    } 
                }
                if(changedCheckbox === 'gents') {
                    if(this.gents) {
                        this.ladies = false;
                        this.all = false;
                    } else if(!this.ladies) {
                        this.gents = true;
                    } 
                }
                */
                if(changedCheckbox === 'acting') {
                    if(this.acting) {
                        this.presenting = false;
                    }
                }
                if(changedCheckbox === 'presenting') {
                    if(this.presenting) {
                        this.acting = false;
                    }
                }
                if(changedCheckbox === 'a_z') {
                    randomizeAllActorsList = true;
                }

                // Reset
                this.actorsPerLines.forEach(actorsPerLine => {
                    if (this.selectedLine === actorsPerLine.line) {
                        $('#'+actorsPerLine.line).collapse('hide');
                    } 
                });
                this.selectedLine = '';
                this.selectedActorId = -1; 
                this.updateActorsPerLines(this.numberOfActorsPerLine, randomizeAllActorsList);
            },
            updateActorsPerLines (numberOfActorsPerLine, randomizeAllActorsList) {
                
                // For Deep-Linking merke actor und actorsPerLine
                var pv_id = "";
                if(this.hash.indexOf("#people?pv_id=") !== -1) {
                    pv_id = this.hash.substring(14);
                }
                console.log(pv_id);

                if(this.a_z) {
                    this.sortActorsAlphabetically();
                } else {
                    if (randomizeAllActorsList) {
                        this.shuffleAllActors();
                    }
                }
                this.numberOfActorsPerLine = numberOfActorsPerLine;
                this.actorsPerLines = [];

                var lineIndex = 0;
                var actorIndex = 0;
                var actors = [];
                this.allActors.forEach(actor => {
                    //Filter male/female actors
                    //alert("actor: " + JSON.stringify(actor) + "\nmale: " + this.actor_male+ "\nfemale: " + this.actor_female);

                    if ((actor.pv_geschlecht === 'm' && actor.pv_actor && this.actor_male)
                     || (actor.pv_geschlecht === 'w' && actor.pv_actor && this.actor_female)
                    /* || (actor.pv_geschlecht === 'm' && actor.pv_moderator && this.moderator_male)
                     || (actor.pv_geschlecht === 'w' && actor.pv_moderator && this.moderator_female)*/
                    ) {
                         //console.log("Add " + JSON.stringify(actor));
                         actors.push(actor);                         
                    }

                    //console.log(this.all + " " + this.ladies + " " + this.gents);
                    /*if ((this.acting && actor.pv_actor && this.all)
                     || (this.acting && actor.pv_actor && actor.pv_geschlecht === 'w' && this.ladies)
                     || (this.acting && actor.pv_actor && actor.pv_geschlecht === 'm' && this.gents)
                     || (this.presenting && actor.pv_moderator && this.all)
                     || (this.presenting && actor.pv_moderator && actor.pv_geschlecht === 'w' && this.ladies)
                     || (this.presenting && actor.pv_moderator && actor.pv_geschlecht === 'm' && this.gents)) {
                         //console.log("Add " + JSON.stringify(actor));
                         actors.push(actor);                         
                    }*/

                    // Deep link
                    if(pv_id === actor.pv_id) {
                        console.log("setdeeplinkActor " + actor);
                        this.deeplinkActor = actor;
                    }

                    actorIndex++;
                    if (actors.length === numberOfActorsPerLine) {
                        this.actorsPerLines.push({
                            line: 'line' + lineIndex,
                            lineIndex: lineIndex,
                            actors: actors
                        });
                        lineIndex++;
                        actorIndex = 0;
                        actors = [];
                    }
                });
                while(actors.length < numberOfActorsPerLine) {
                    var id = -1*(numberOfActorsPerLine-actors.length);
                    this.dummyActor.pv_id = id;
                    actors.push( {
                        pv_id:id,
                        pv_vorname:this.dummyActor.pv_vorname,
                        pv_nachname:this.dummyActor.pv_nachname,
                        pv_geschlecht:this.dummyActor.pv_geschlecht,
                        pv_bild:this.dummyActor.pv_bild
                        });
                }
                this.actorsPerLines.push({
                    line: 'line' + lineIndex,
                    lineIndex: lineIndex,
                    actors: actors
                });
            }
        } ,
        created() {
            //window.addEventListener('scroll', this.storeScrollValues);
            eventBus.$on('selectActor', (data) => {                              
                if (this.selectedActorId === data.actor.pv_id) {
                    //alert('Same Actor ' + JSON.stringify(data));
                    this.selectedLine = '';
                    this.selectedActorId = -1; // Reset
               } else {
                    //alert('New Actor ' + JSON.stringify(data));
                    this.selectedLine = data.line;
                    this.selectedActorId = data.actor.pv_id;
                }
                this.hideAllCollapsedContent(data);

                //window.addEventListener('resize', function(e) {
                //    console.log("RESIZE");
                //});
                //window.resizeTo(500,500);
            });

            //this.$http.get(url.scheme + '://service.heimanns-agentur.de/api/people')
            this.$http.get(url.scheme + '://relaunch2018.heimanns-agentur.de/api/people')
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    this.allActors = data.results;
                    console.log("All Actors fetched from DB");
                    this.startUpdate();

                    //Beispiel: http://localhost:8080/#people?pv_id=58
                    //console.log("Hash=" + this.hash);                    
                    
                    if(this.hash.indexOf("#people?pv_id=") !== -1) {
                        var pv_id = this.hash.substring(14);
                        //console.log ("Deep-Link for pv_id = " + pv_id);
                        if(pv_id > -1) {
                            setTimeout(() => {                                
                                $('#' + this.deeplinkActor.pv_id).trigger("toggle.collapse");
                                $('#thumb_' + this.deeplinkActor.pv_id).trigger("click");
                            }, 200); 
                        }  
                    }
            });
        } 
    }
</script>

<style>
        .btn-filter,
        .btn-filter:focus {
            color:#495561 !important;
            margin-right:0px;
            margin-left:0px;
            border-radius:0px;
            padding-left:15px;
            padding-right:15px;
            min-width:64px;
        }
        .btn-filter:hover,
        .btn-filter:focus {
            color:white !important;
            background: #0188c0!important;
        }
        .btn-filter.active {
            color:#0188c0 !important;
            background: white!important;
            border-bottom: 4px #0188c0 solid
        }

        .picture1 {
            background: url("./../assets/img/strahlen.png") top right no-repeat;
            background-attachment:fixed;

        }

        .container.people-width {
            min-width:91%;
        }
        @media (max-width: 1200px) {
            .container.people-width {
                min-width:88%;
                max-width:91%
            }
        }
        @media (max-width: 992px) {
            .container.people-width {
                min-width:85%;
                max-width:85%;
            }
        }

        [type=checkbox]+label, [type=radio]+label {
            line-height: 21px;
        }
        @media (max-width: 575px) {
            [type=checkbox]+label, [type=radio]+label {
                /*font-size: 1.25rem;*/
                padding-left: 28px;
            }
            .adjust-left-xs {
                margin-left:-10%;
            }
        }
        @media (max-width: 320px) {
            .adjust-left-xs {
                margin-left:-30%;
            }
        }
        .checkbox-rounded-heimanns-red [type="checkbox"][class*='filled-in']+label:after {
            border-radius: 50%;
            border-color: #0188c0;
            background-color: transparent;
        }
        .checkbox-rounded-heimanns-red [type="checkbox"][class*='filled-in']:checked+label:after {
            background-color: #0188c0;
        }
        .checkbox-rounded-heimanns-blue [type="checkbox"][class*='filled-in']+label:after {
            border-radius: 50%;
            border-color: #73d9e5;
            background-color: transparent;
        }
        .checkbox-rounded-heimanns-blue [type="checkbox"][class*='filled-in']:checked+label:after {
            background-color: #73d9e5;
        }
        
        
        a.btn.btn-rounded.heimanns-red {
            background-color: #0188c0;
        }
        a.btn.btn-rounded.heimanns-red:hover {
            background-color: #73d9e5;
        }
        
        span.badge.heimanns-red {
            background-color: #0188c0;
        }
        span.badge.heimanns-blue {
            background-color: #73d9e5;
        }


</style>




// WEBPACK FOOTER //
// src/components/People.vue